export const AlertsOn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 8 8"
    fill="none"
  >
    <g clip-path="url(#clip0_167_786)">
      <path
        d="M3.15527 7C3.20922 7.10134 3.2868 7.18549 3.38022 7.244C3.47365 7.3025 3.57963 7.3333 3.6875 7.3333C3.79538 7.3333 3.90136 7.3025 3.99478 7.244C4.08821 7.18549 4.16579 7.10134 4.21973 7"
        stroke="#fff"
        stroke-width="0.789612"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.00265 5.10863C0.962506 5.15635 0.936014 5.21571 0.926396 5.27947C0.916779 5.34322 0.924449 5.40864 0.948476 5.46776C0.972502 5.52688 1.01185 5.57714 1.06173 5.61245C1.11161 5.64776 1.16987 5.66658 1.22943 5.66663H6.1461C6.20566 5.66665 6.26393 5.6479 6.31384 5.61266C6.36375 5.57742 6.40315 5.52721 6.42724 5.46813C6.45133 5.40905 6.45908 5.34365 6.44953 5.27989C6.43999 5.21612 6.41358 5.15674 6.3735 5.10896C5.9648 4.65196 5.53152 4.16629 5.53152 2.66663C5.53152 2.13619 5.33727 1.62749 4.9915 1.25241C4.64573 0.87734 4.17676 0.666626 3.68777 0.666626C3.19877 0.666626 2.72981 0.87734 2.38404 1.25241C2.03827 1.62749 1.84401 2.13619 1.84401 2.66663C1.84401 4.16629 1.41043 4.65196 1.00265 5.10863Z"
        stroke="#fff"
        stroke-width="0.789612"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_167_786">
        <rect width="7.37501" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AlertsOff = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 8 8"
    fill="none"
  >
    <g clip-path="url(#clip0_167_818)">
      <path
        d="M3.15503 7C3.20897 7.10134 3.28656 7.18549 3.37998 7.244C3.47341 7.3025 3.57938 7.3333 3.68726 7.3333C3.79514 7.3333 3.90111 7.3025 3.99454 7.244C4.08796 7.18549 4.16555 7.10134 4.21949 7"
        stroke="#D1D5DB"
        stroke-width="0.758077"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.22407 5.66673H1.22928C1.16972 5.66675 1.11145 5.648 1.06154 5.61276C1.01163 5.57752 0.972229 5.52731 0.948139 5.46823C0.924049 5.40915 0.916304 5.34375 0.925845 5.27999C0.935386 5.21622 0.961802 5.15684 1.00188 5.10906C1.41058 4.65206 1.84386 4.16639 1.84386 2.66673C1.84382 2.46999 1.87053 2.27433 1.92314 2.08606"
        stroke="#D1D5DB"
        stroke-width="0.758077"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.614502 0.666626L6.76034 7.33329"
        stroke="#D1D5DB"
        stroke-width="0.758077"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66357 1.00337C2.94121 0.802265 3.26397 0.686702 3.59741 0.669014C3.93086 0.651325 4.26247 0.732176 4.55687 0.902937C4.85127 1.0737 5.0974 1.32796 5.269 1.63859C5.44061 1.94923 5.53124 2.30457 5.53122 2.6667C5.53122 3.56237 5.76784 4.2177 6.05577 4.68337"
        stroke="#D1D5DB"
        stroke-width="0.758077"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_167_818">
        <rect width="7.37501" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExploreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.333"
      d="M10 2h4v4M6.667 9.333 14 2m-2 6.667v4A1.334 1.334 0 0 1 10.667 14H3.333A1.334 1.334 0 0 1 2 12.667V5.333A1.333 1.333 0 0 1 3.333 4h4"
    />
  </svg>
);

export const ShowViewIcon = ({
  className,
  onClick,
  ...rest
}: {
  onClick: () => void;
  className: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
    onClick={onClick}
    {...rest}
  >
    <path
      stroke="#0097D8"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.333"
      d="M10 2h4v4M6.667 9.333 14 2m-2 6.667v4A1.334 1.334 0 0 1 10.667 14H3.333A1.334 1.334 0 0 1 2 12.667V5.333A1.333 1.333 0 0 1 3.333 4h4"
    />
  </svg>
);
